import numeral from "numeral";
import React from "react";
import { Pie, Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import API from "../../utils/API";
import { isBiro, satuan, singkatan_nama_perusahaan } from "../../utils/helper";

export default (props) => {
  const chartFilter = useSelector((state) => state.chartFilterReducer);
  const chartFilterDashboard = useSelector(
    (state) => state.chartFilterDashboard
  );
  const companies = useSelector(
    (state) => state.perusahaanReducer.listPerusahaan
  );
  const [data, setData] = React.useState([]);
  const [rawData, setRawData] = React.useState([]);
  const [legend, setLegend] = React.useState([]);
  const { year, type, startMonth, endMonth } = chartFilter;
  const [isThereNegative, setIsThereNegative] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [totalTidakLancar, setTotalTidakLancar] = React.useState(0);
  const user = useSelector((state) => state.main.dataUser);
  const optionsBar = {
    responsive: true,
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const n = tooltipItem.index;
          return data.labels[n];
        },
        footer: (tooltipItems, data) => {
          return "Rp " + numeral(tooltipItems[0].yLabel).format(0, 0);
        }
      }
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            display: true,
            beginAtZero: true,
            callback: function (val, index) {
              return satuan(val);
            }
          }
        }
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            display: false
          }
        }
      ]
    }
  };

  const optionsBarShowYear = {
    responsive: true,
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const n = tooltipItem.index;
          return data.years[n];
        },
        footer: (tooltipItems, data) => {
          return "Rp " + numeral(tooltipItems[0].yLabel).format(0, 0);
        }
      }
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            display: true,
            beginAtZero: true,
            callback: function (val, index) {
              return satuan(val);
            }
          }
        }
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            display: false
          }
        }
      ]
    }
  };

  const getValuesLancar = (raws) => {
    let negativeCounter = 0;
    for (const rd of raws) {
      if (rd.assetLancar === null || rd.assetLancar <= 0) negativeCounter++;
    }
    if (negativeCounter === raws.length) return raws.map((o) => o.assetLancar);
    return raws.map((o) => (o.assetLancar == null ? 0 : o.assetLancar));
  };
  const getValuesTidakLancar = (raws) => {
    let negativeCounter = 0;
    for (const rd of raws) {
      if (rd.assetTidakLancar === null || rd.assetTidakLancar <= 0)
        negativeCounter++;
    }
    if (negativeCounter === raws.length)
      return raws.map((o) => o.assetTidakLancar);
    return raws.map((o) =>
      o.assetTidakLancar == null ? 0 : o.assetTidakLancar
    );
  };

  const getData = async () => {
    if (companies.content.length === 0 && isBiro()) {
      var url =
        `/chart/${props.type.url}?startYear=${chartFilterDashboard.startYear}&endYear=${chartFilterDashboard.endYear}&` +
        `type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${chartFilterDashboard.bumd}`;

    } else
      var url =
        `/chart/${props.type.url}?startYear=${chartFilterDashboard.startYear}&endYear=${chartFilterDashboard.endYear}&` +
        `type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${user.perusahaan == null ? chartFilterDashboard.bumd : user.perusahaan.id}`;


    // if (props.type.url == "asset-all" && rawData.length > 1 && isBiro()) {
    //   url =
    // `/chart/${props.type.url}?startYear=${chartFilterDashboard.endYear - 2}&endYear=${chartFilterDashboard.endYear}&` +
    // `type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${chartFilterDashboard.bumd}`;
    // }

    if (props.url == 1) {
      url = `/chart/${props.type.url}?year=${chartFilterDashboard.endYear}&type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}`;
    }

    url = url.trim();
    // const url = `/chart/${props.type.url}?year=${year}&type=${type}&startMonth=${startMonth}&endMonth=${endMonth}`;
    const r = await API.get(url);
    const d = r.data;
    handleSum(d);
    checkThereNegative(r.data);
    const comp = companies.content;
    var arrayBg = isBiro()
      ? d.map((o) => comp.filter((c) => c.id === o.perusahaanId)[0]?.color)
      : ["#28a745"];

    arrayBg.forEach(function (part, index, theArray) {
      theArray[index] = hexToRgbA(theArray[index]);
    });

    var chartData = {};
    if (
      chartFilterDashboard.bumd == "" ||
      chartFilterDashboard.bumd == null ||
      chartFilterDashboard.bumd == 1 ||
      chartFilterDashboard.bumd == 2 ||
      chartFilterDashboard.bumd == 0
    ) {
      chartData = {
        labels: d.map((o) => o.perusahaanName),
        years: d.map((o) => o.year),
        datasets: [
          {
            labels: "data1",
            data: getValuesLancar(d),
            backgroundColor: isBiro()
              ? d.map(
                (o) => comp.filter((c) => c.id === o.perusahaanId)[0]?.color
              )
              : "#28a745"
          },
          {
            labels: "data2",
            data: getValuesTidakLancar(d),
            backgroundColor: arrayBg
          }
        ]
      };
    } else {
      chartData = {
        labels: d.map((o) => o.perusahaanName),
        years: d.map((o) => o.year.toString()),
        datasets: [
          {
            labels: "data1",
            data: getValuesLancar(d),
            backgroundColor: isBiro()
              ? d.map(
                (o) => comp.filter((c) => c.id === o.perusahaanId)[0]?.color
              )
              : "#28a745"
          },
          {
            labels: "data2",
            data: getValuesTidakLancar(d),
            backgroundColor: arrayBg
          }
        ]
      };
    }
    createDataLegend(chartData);
    setData(chartData);
    setRawData(d);
  };

  const hexToRgbA = (hex) => {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",0.5)"
      );
    }
    throw new Error("Bad Hex");
  };

  const createDataLegend = (par) => {
    if (par) {
      var arrayTitle = par.labels;
      var arrayYear = par.years;
      var value = par.datasets[0].data;
      var value2 = par.datasets[1].data;
      var bg = par.datasets[0].backgroundColor;
      var tmp = [];
      for (var i = 0; i < arrayTitle.length; i++) {
        var obj = {
          title: arrayTitle[i],
          year: arrayYear[i],
          value: value[i],
          value2: value2[i],
          bg: bg[i]
        };
        tmp.push(obj);
      }

      setLegend(tmp);
    }
  };

  const checkThereNegative = (data) => {
    if (data) {
      var inc = 0;
      data.map((r, i) => {
        if (r.value < 0) {
          inc++;
          setIsThereNegative(inc);
        }
      });
    }
  };

  const isValidData = () => {
    if (isBiro()) {
      if (rawData.length === 0) return 0;
      let negativeCounter = 0;
      for (const rd of rawData) {
        if (rd.value > 0) return 1;
        else negativeCounter++;
      }
      if (negativeCounter === rawData.length) return 2;
      return 0;
    } else {
      if (rawData[0]?.value === null) return 0;
      if (rawData.length === 0) return 0;
      let negativeCounter = 0;
      for (const rd of rawData) {
        if (rd.value > 0) return 1;
        else negativeCounter++;
      }
      if (negativeCounter === rawData.length) return 2;
      return 0;
    }
  };

  const handleSum = (data) => {
    var total = 0;
    var totalTidakLancar = 0;
    data.map((r, i) => {
      total += r.assetLancar;
      totalTidakLancar += r.assetTidakLancar;
    });
    total = satuan(total);
    totalTidakLancar = satuan(totalTidakLancar);
    setTotal(total);
    setTotalTidakLancar(totalTidakLancar);
  };

  const datasetKeyProvider = () => {
    return Math.random();
  };

  React.useEffect(() => {
    getData();
  }, [companies, chartFilterDashboard]);
  if (data.length === 0) return <></>;
  const circleChart = {
    height: "151px",
    width: "100%",
    backgroundColor: "rgba(160, 160, 160, 0.9)",
    borderRadius: "100%",
    position: "relative"
  };
  const circleChartText = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    textAlign: "center"
  };

  if (
    chartFilterDashboard.bumd == "" ||
    chartFilterDashboard.bumd == null ||
    chartFilterDashboard.bumd == 1 ||
    chartFilterDashboard.bumd == 2 ||
    chartFilterDashboard.bumd == 0
  ) {
    return (
      <div className="col-md-4" style={{ marginTop: 20 }}>
        {isValidData() === 0 ? (
          <div style={circleChart}>
            <small style={circleChartText}>data tidak cukup/valid</small>
          </div>
        ) : (
          <div>
            <h5 style={{ textAlign: "end" }}>Lancar: {total}, Tidak Lancar: {(totalTidakLancar)}</h5>
            <Bar
              data={data}
              options={optionsBarShowYear}
              width={1}
              height={1}
              datasetKeyProvider={datasetKeyProvider}
            />
          </div>
        )}
        <p className="font-weight-bold text-center mt-2">{props.type.title}</p>

        {/* <span>Asset Lancar</span>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap"
        }}
      >
        {legend.map((r, i) => {
          return (
            <div
              key={i}
              style={{
                marginLeft: 20,
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  backgroundColor: r.bg,
                  height: 10,
                  width: 10,
                  borderRadius: 5,
                  marginRight: 5
                }}
              />
              <span>
                {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                {satuan(r.value)})
              </span>
            </div>
          );
        })}
      </div>
      <span>Asset Tidak Lancar</span>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap"
        }}
      >
        {legend.map((r, i) => {
          return (
            <div
              key={i}
              style={{
                marginLeft: 20,
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  backgroundColor: r.bg,
                  height: 10,
                  width: 10,
                  borderRadius: 5,
                  marginRight: 5
                }}
              />
              <span>
                {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                {satuan(r.value2)})
              </span>
            </div>
          );
        })}
      </div> */}

      </div>
    );
  }

  return (
    <div className="col-md-4" style={{ marginTop: 20 }}>
      {isValidData() === 0 ? (
        <div style={circleChart}>
          <small style={circleChartText}>data tidak cukup/valid</small>
        </div>
      ) : (
        <div>
          <h5 style={{ textAlign: "end" }}>Lancar: {total}, Tidak Lancar: {(totalTidakLancar)}</h5>

          <Bar
            data={data}
            options={optionsBarShowYear}
            width={1}
            height={1}
            datasetKeyProvider={datasetKeyProvider}
          />
        </div>
      )}
      <p className="font-weight-bold text-center mt-2">{props.type.title}</p>
      {/* <span>Asset Lancar</span>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap"
        }}
      >
        {legend.map((r, i) => {
          return (
            <div
              key={i}
              style={{
                marginLeft: 20,
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  backgroundColor: r.bg,
                  height: 10,
                  width: 10,
                  borderRadius: 5,
                  marginRight: 5
                }}
              />
              <span>
                {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                {satuan(r.value)})
              </span>
            </div>
          );
        })}
      </div>

      <span>Asset Tidak Lancar</span>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap"
        }}
      >
        {legend.map((r, i) => {
          return (
            <div
              key={i}
              style={{
                marginLeft: 20,
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  backgroundColor: r.bg,
                  height: 10,
                  width: 10,
                  borderRadius: 5,
                  marginRight: 5
                }}
              />
              <span>
                {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                {satuan(r.value2)})
              </span>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

// var daaaa = {
//   labels: ["PT Agro Jabar", "PT Jaswita", "PT Agronesia"],
//   datasets: [
//     {
//       data: [59425279912, 123767300642, 59257916392],
//       backgroundColor: ["#43A047", "#8E44AD", "#C36839"]
//     }
//   ]
// };
